export const DESCEND_FIRST_SORTING_ORDER = ['desc', 'asc', null];
export const ASCEND_FIRST_SORTING_ORDER = ['asc', 'desc', null];
export var DataMode;
(function (DataMode) {
    DataMode["SERVER"] = "server";
    DataMode["CLIENT"] = "client";
})(DataMode || (DataMode = {}));
export const DEFAULT_PAGE_SIZES = [25, 50, 100];
export const DEFAULT_PAGE_SIZE = 25;
export const SCROLLBAR_SIZE = 0;
export const HEADER_HEIGHT = 40;
export const ROW_HEIGHT = 56;
export const MAXIMUM_SELECTED_COLUMNS = 10;
//# sourceMappingURL=index.js.map